import { Chip, Paper, TextField, Grid2 } from "@mui/material"
import Autocomplete from "@mui/material/Autocomplete"
import { isArray, isString } from "lodash"
import toastError from "../../errors/toastError"
import api from "../../services/api"

export function TagsContainer({ tags, selecteds, setSelecteds, loadTags }) {
    const createTag = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags`, data)
            return responseData
        } catch (error) {
            toastError(error)
        }
    }

    const onChange = async (value, reason) => {
        let optionsChanged = []

        if (reason === "create-option") {
            if (isArray(value)) {
                for (const item of value) {
                    if (isString(item)) {
                        const newTag = await createTag({ name: item })
                        optionsChanged.push(newTag)
                    } else {
                        optionsChanged.push(item)
                    }
                }
            }
            await loadTags()
        } else {
            optionsChanged = value
        }

        setSelecteds(optionsChanged)
    }

    return (
        <Grid2 display="flex" sx={{ mb: 1 }}>
            <Grid2 flexBasis="100%">
                <Autocomplete
                    multiple
                    size="small"
                    options={tags}
                    value={selecteds}
                    freeSolo
                    onChange={(e, value, reason) => onChange(value, reason)}
                    getOptionLabel={(option) =>
                        option.name ? option.name : ""
                    }
                    isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                    }
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip
                                key={option.id || index}
                                variant="outlined"
                                style={{
                                    backgroundColor: option.color || "#eee",
                                    color: "white",
                                    textShadow: "1px 1px 1px #000",
                                }}
                                label={option.name}
                                {...getTagProps({ index })}
                                size="small"
                            />
                        ))
                    }
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Tags"
                        />
                    )}
                    PaperComponent={({ children }) => (
                        <Paper style={{ width: 400, marginLeft: 12 }}>
                            {children}
                        </Paper>
                    )}
                />
            </Grid2>
        </Grid2>
    )
}
